import { render, staticRenderFns } from "./InstagramInstantwinPrizeTable.vue?vue&type=template&id=28d4d0fc&scoped=true"
import script from "./InstagramInstantwinPrizeTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramInstantwinPrizeTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramInstantwinPrizeTable.vue?vue&type=style&index=0&id=28d4d0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d4d0fc",
  null
  
)

export default component.exports